<template>
  <div class="rules-page">
    <h2 class="section-title">Pravidla soutěže</h2>
    
    <p>
      Kompletni znění pravidel je možné stáhnout v PDF formě <a href="/pravidla.pdf" download>zde</a>.
    </p>
    
    <div class="card mb-4 custom-card">
      <div class="card-body">
        <h3 class="card-title">Základní pravidla</h3>
        <ul class="list-group list-group-flush">
          <li class="list-group-item">
            <h5>1. Hráči</h5>
            <ol>
              <li>
                Soutěž je určena pro neomezený počet neregistrovaných hráčů (dále jen „N”), kteří nejsou a nikdy nebyli registrováni v žádné soutěži řízené ČSLH a ČSTV v jakékoliv hráčské kategorii s žádným věkovým omezením včetně okresního přeboru.               </li>
              <li>
                Soutěž je určena i pro bývalé registrované hráče (dále jen „R”), kteří nastupovali pouze v mládežnických kategoriích a již hokej na profesionální úrovni nehrají.
                <ul>
                  <li>
                    Tyto výjimky jsou uplatňovány pro posouzení „R“ hráče.
                    <ul>
                      <li>Pokud hráč aktivně hrál hokej pouze do kategorie žáci U10, v tom případě hráč není „R“.</li>
                      <li>Hráči nad 50 let rovněž nemají status „R“ hráče.</li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                Soutěže se mohou účastnit hráči starší 18 let. Hráči mladší 18 let, musí mít potvrzení zákonného zástupce, kde vysloveně hráč a jeho zákonný zástupce přebírá plnou zodpovědnost za sebe. Soutěž ani tým nejsou zodpovědní za případná zranění ani pozdější soudní spory.              </li>
                
            </ol>
          </li>
          <li class="list-group-item">
            <h5>2. Bodování</h5>
            <p>Za výhru 3 body, za remízu 1 bod, za prohru 0 bodů.</p>
          </li>
          <li class="list-group-item">
            <h5>3. Pořadí v tabulce</h5>
            <p>Pořadí v tabulce se určuje podle počtu bodů. Při rovnosti bodů rozhoduje:</p>
            <ol>
              <li>Vzájemné zápasy (platné pouze po skončení sezóny a odehrání všech zápasů)</li>
              <li>Rozdíl vstřelených a obdržených gólů</li>
              <li>Počet vstřelených gólů</li>
              <li>Počet obdržených gólů</li>
            </ol>
          </li>
          <li class="list-group-item">
            <h5>4. Hrací doba</h5>
            <p>Zápas se hraje 3 x 15 minut čistého času s 2 minutovou přestávkou mezi třetinami viz sekce Pravidla - Doba zápasu a hrací doba.</p>
          </li>
          <li class="list-group-item">
            <h5>5. Minimální počet hráčů</h5>
            <p>Na soupisce musí být minimálně 1 brankář, 3 obránci a 4 útočníci (8 hráčů celkem).</p>
          </li>
        </ul>
      </div>
    </div>

    <div class="card mb-4 custom-card">
      <div class="card-body">
        <h3 class="card-title">Disciplinární pravidla</h3>
        <ul class="list-group list-group-flush">
          <li class="list-group-item">
            <h5>1. Vyloučení</h5>
            <p>Vyloučený hráč se odebere na trestnou lavici, kde stráví 2:00 minuty hrubého času.</p>
          </li>
          <li class="list-group-item">
            <h5>2. Disciplinární tresty</h5>
            <p>Za hrubé či nesportovní chovaní mohou být uděleny mimořadné postihy viz sekce Dokumenty - Trestní řád.</p>
          </li>
        </ul>
      </div>
    </div>

    <div class="card custom-card">
      <div class="card-body">
        <h3 class="card-title">Technické požadavky</h3>
        <ul class="list-group list-group-flush">
          <li class="list-group-item">
            <h5>1. Výstroj</h5>
            <p>Všichni hráči musí mít kompletní hokejovou výstroj včetně chráničů a helmy.</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RulesPage'
}
</script>

<style scoped>
.rules-page {
  max-width: 1200px;
  margin: 0 auto;
  background: #0a1023;
  color: #e0e6f7;
  min-height: 100vh;
  padding: 2rem 1rem 3rem;
}

.section-title {
  background: linear-gradient(135deg, #1fe0ff, #0a7cff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 800;
  letter-spacing: -0.02em;
  line-height: 1.15;
  font-size: 1.75rem;
  margin-bottom: 1.5rem;
}

.custom-card {
  background: #151d3a;
  color: #e0e6f7;
  border: 1px solid rgba(31, 224, 255, 0.08);
  border-radius: 0.75rem;
  margin-bottom: 2rem;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.custom-card:hover {
  border-color: rgba(31, 224, 255, 0.15);
  box-shadow: 0 8px 24px rgba(10, 16, 35, 0.4);
}

.card-title {
  color: #1fe0ff;
  font-weight: 700;
  font-size: 1.2rem;
}

.list-group-item {
  background: rgba(31, 224, 255, 0.04);
  color: #e0e6f7;
  border: 1px solid rgba(31, 224, 255, 0.06);
  border-radius: 0.5rem;
  font-size: 1.05rem;
  margin-bottom: 0.5rem;
  transition: all 0.2s ease;
}

.list-group-item:hover {
  border-color: rgba(31, 224, 255, 0.12);
  background: rgba(31, 224, 255, 0.06);
}

.list-group-item h5 {
  color: #1fe0ff;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.list-group-item p {
  margin-bottom: 0.5rem;
  color: #e0e6f7;
}

.list-group-item ol {
  margin-bottom: 0;
  padding-left: 1.5rem;
  color: #8892b0;
}
</style> 